import { useMediaQuery } from 'react-responsive';
import { breakpoints } from 'assets/breakpoints';
import useWindowDimension from './useWindowDimensions';

const useResponsive = () => {
  const { winWidth, winHeight } = useWindowDimension();

  const isTabletView = useMediaQuery({
    query: `(min-width: ${breakpoints.tablet})`,
  });
  const isLargeView = useMediaQuery({
    query: `(min-width: ${breakpoints.desktop})`,
  });
  const isMobileView = isTabletView
        && !isLargeView;

  const getViewType = () => {
    if (isMobileView) return 'mobile';
    if (isLargeView) return 'large';
    return 'tablet';
  };

  const viewType = getViewType();

  return {
    isLargeView,
    isMobileView,
    isTabletView,
    winHeight,
    winWidth,
    viewType,
  };
};

export default useResponsive;
